export default [
  {
    type: 'template',
    title: 'bird',
    name: 'bird',
    size: 'lg',
  },
  {
    type: 'text',
    title: 'family_group',
    name: 'familyGroup',
    size: 'sm',
  },
  {
    type: 'text',
    title: 'family',
    name: 'family',
    size: 'sm',
  },
  {
    type: 'actions',
    title: 'actions',
    name: 'actions',
    size: 'md',
  },
];
